<script>
export default {
  data() {
    return {
      valid: false,
      ruleNotNull: [(v) => !!v || "Required"],
      ruleValidOptionalEmail: [
        (v) => {
          // If emailAddress field does not have any value, skip validation
          if (v.trim().length === 0) return true;

          return (
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v
            ) || "E-mail must be valid"
          );
        },
      ],
      ruleValidEmail: [
        (v) => !!v || "E-mail is required",
        // from http://emailregex.com/
        (v) =>
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail must be valid",
      ],
      //Commented out ruleConfirmEmail rule incase it is needed in the future
      // ruleConfirmEmail: [
      //   (v) =>
      //     // we need to make sure both v and emailAddress are not null before attempting the replace/compare
      //     (v &&
      //       this.emailAddress &&
      //       v.replace(/\s/g, "") === this.emailAddress.replace(/\s/g, "")) ||
      //     "Confirm Email must be the same email",
      // ],
      ruleValidNumber: [
        (v) =>
          (v &&
            (/^(?:\+?61|0)\s?[2-478](?:\s?[ -]?\s?[0-9]){8}$/.test(
              v.replace(/\s/g, "")
            ) || //australia / NZ mobile/landline/fax
              /^02[0-2,6-9](\s|-|)\d{3,4}(\s|-|)\d{3,4}$/.test(
                v.replace(/\s/g, "")
              ))) ||
          "Must be a valid AU or NZ number",
      ],
      ruleValidMobile: [
        (v) =>
          (v &&
            /^(?:\+?61|0)\s?[4-9](?:\s?[ -]?\s?(?!.*(\d)\1{7})[0-9]){8}$/.test(
              v.replace(/\s/g, "")
            )) || // Australia mobile
          /^(?:\+?64|0)\s?[278](?!.*(\d)\1{7})\d{7,9}$/.test(
            v.replace(/\s/g, "")
          ) || // New Zealand mobile
          "Must be a valid AU or NZ mobile number",
      ],
      // Can't use ruleNotNull for booleans, as that's a non-falsy check
      ruleValidBoolean: [(v) => typeof v === "boolean" || "Required"],
      ruleProviderNumber: [
        (v) => (v && v.length === 8) || "Provider Number must be 8 characters",
        (v) => /[0-9]{6}/.test(v) || "First 6 characters must be a number",
        (v) =>
          /^[0-9a-zA-Z]+$/.test(v[6]) || "7th character must be Alphanumeric",
        (v) => /^[a-zA-Z]+$/.test(v[7]) || "8th character must be a letter",
      ],
      ruleMaxCustomGenes: [
        (v) => v.length <= 5 || "Cannot select more than 5 genes",
      ],
      ruleMaxGenePanelsForPrenatal: [
        (v) => v.length <= 1 || "Cannot select more than 1 gene panel",
      ],

      rulePostCode: [
        (v) =>
          (v !== null && !isNaN(v) && v.length === 4) ||
          "Postcode needs to be 4 digits",
      ],

      ruleMedicareNum: [
        (v) => {
          v = v.replace(/\s/g, "");
          return (
            // There might be some issues with this logic as some medicare numbers are failing.
            // Reverting to a simple 10 digit check for now and will revisit later.
            // (v !== null &&
            //   !isNaN(v) &&
            //   v.length === 10 &&
            //   v[0] in [2, 3, 4, 5, 6] &&
            //   this.medicareCheckSum(v.slice(0, 8), v[8])) ||
            (v !== null && !isNaN(v) && v.length === 10) ||
            "Medicare Number must be 10 digits"
          );
        },
      ],
      ruleMedicarePosNo: [
        (v) =>
          (v !== null && !isNaN(v) && v.length === 1) ||
          "Medicare Position Number must be 1 digit",
        (v) => v > 0 || "Medicare Position cannot be 0",
      ],
      ruleMedicareItemNumber: [
        (v) =>
          (v !== null &&
            !isNaN(v) &&
            v.trim().length <= 5 &&
            v.trim().length > 0) ||
          "Medicare item number must be a set of numbers and can be up to 5 numbers long",
      ],
      ruleDOBday: [
        (v) =>
          (v !== null && !isNaN(v) && parseInt(v) > 0 && parseInt(v) <= 31) ||
          "Specify a numeric DOB day e.g. 31",
      ],
      ruleDOBmonth: [
        (v) =>
          (v !== null && !isNaN(v) && parseInt(v) > 0 && parseInt(v) <= 12) ||
          "Specify a numeric DOB month e.g. 12",
      ],
      ruleDOByear: [
        (v) =>
          (v !== null &&
            !isNaN(v) &&
            parseInt(v) > 1801 &&
            parseInt(v) <= 9999) ||
          "Specify a numeric DOB year e.g. 2002",
      ],
      ruleDate: [
        (v) =>
          /^((0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/[12]\d{3})$/.test(v) ||
          "DOB must be in dd/mm/yyyy format",
      ],

      ruleStoredSampleId: [
        (v) =>
          (v !== null && v.length < 20) ||
          "Sample ID must be under 20 characters",
      ],
      ruleVariantDetails: [(v) => v.length <= 100 || "Character limit is 100"],
      limitTitle: 20,
      limitSurname: 50,
      limitGivenName: 50,
      limitExternalID: 25,
      limitGender: 20,
      limitDay: 2,
      limitMonth: 2,
      limitYear: 4,
      limitMobile: 20,
      limitPhone: 20,
      limitFax: 20,
      limitEmail: 50,
      limitClinicName: 78,
      limitDeptSuite: 100,
      limitUnitFlatLevel: 50,
      limitStreetAddress: 50,
      limitSuburb: 30,
      limitState: 20,
      limitPostCode: 10,
      limitCountry: 20,
      limitUseDifferentAddress: 20,
      limitEthnicity: 20,
      limitRelationAffected: 100,
      limitProviderNum: 20,
      limitMedicareCardNum: 20,
    };
  },
  methods: {
    cleanPhoneNumber(phoneNumber) {
      return (phoneNumber || "").replace(/[^0-9]/g, "");
    },
    medicareCheckSum(identifier, checkSumDigit) {
      // Check sum the 8 digit identifier according to weights
      // See https://clearwater.com.au/code/medicare for details
      let weights = [1, 3, 7, 9, 1, 3, 7, 9];
      let sum = 0;
      for (let idx = 0; idx < weights.length; idx++) {
        let weight = weights[idx];
        sum += parseInt(identifier[idx]) * weight;
      }
      return sum % 10 === parseInt(checkSumDigit);
    },
    validateForm() {
      if ("form" in this.$refs) {
        this.valid = this.$refs.form.validate();
      }
      return this.valid;
    },
  },
};
</script>
